import React from 'react'
import PropTypes from 'prop-types'
import SelectLanguage from './SelectLanguage'
import UpdateProfile from './UpdateProfile'

export const types = {
  language: 'language',
  profile: 'profile'
}

export default function UserMenuDialogSwitcher ({ type, onClose }) {
  switch (type) {
    case types.language:
      return <SelectLanguage onClose={onClose} />
    case types.profile:
      return <UpdateProfile onClose={onClose} />

    default:
      return null
  }
}

UserMenuDialogSwitcher.propTypes = {
  type: PropTypes.oneOf(Object.values(types)),
  onClose: PropTypes.func.isRequired
}
